var _style, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconPunchcard(_ref, svgRef) {
  var {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "43px",
    height: "43px",
    viewBox: "0 0 43 43",
    style: {
      enableBackground: "new 0 0 43 43"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "punchcard"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M35.3387,10.9212H8.83l-4.1162,4.1163v14.0087c0,1.7231,1.4019,3.125,3.125,3.125h27.5 c1.7231,0,3.125-1.4019,3.125-3.125v-15C38.4637,12.3237,37.0619,10.9212,35.3387,10.9212z M37.2137,29.0462 c0,1.0338-0.8413,1.875-1.875,1.875h-27.5c-1.0338,0-1.875-0.8412-1.875-1.875V15.555l3.3837-3.3831l25.9913-0.0006 c1.0337,0,1.875,0.8413,1.875,1.875V29.0462z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 10.3387,
    y: 15.2962,
    className: "st0",
    width: 1.25,
    height: 1.25
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 16.5887,
    y: 15.2962,
    className: "st0",
    width: 1.25,
    height: 1.25
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 19.0887,
    y: 15.2962,
    className: "st0",
    width: 1.25,
    height: 1.25
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 26.5887,
    y: 15.2962,
    className: "st0",
    width: 1.25,
    height: 1.25
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 29.0887,
    y: 15.2962,
    className: "st0",
    width: 1.25,
    height: 1.25
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 10.3387,
    y: 19.0462,
    className: "st0",
    width: 1.25,
    height: 1.25
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 12.8387,
    y: 19.0462,
    className: "st0",
    width: 1.25,
    height: 1.25
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 15.3387,
    y: 19.0462,
    className: "st0",
    width: 1.25,
    height: 1.25
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 17.8387,
    y: 19.0462,
    className: "st0",
    width: 1.25,
    height: 1.25
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 21.5887,
    y: 19.0462,
    className: "st0",
    width: 1.25,
    height: 1.25
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 24.0887,
    y: 19.0462,
    className: "st0",
    width: 1.25,
    height: 1.25
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 32.8387,
    y: 19.0462,
    className: "st0",
    width: 1.25,
    height: 1.25
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 30.3387,
    y: 22.7962,
    className: "st0",
    width: 1.25,
    height: 1.25
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 24.0887,
    y: 22.7962,
    className: "st0",
    width: 1.25,
    height: 1.25
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 21.5887,
    y: 22.7962,
    className: "st0",
    width: 1.25,
    height: 1.25
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 14.0887,
    y: 22.7962,
    className: "st0",
    width: 1.25,
    height: 1.25
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 11.5887,
    y: 22.7962,
    className: "st0",
    width: 1.25,
    height: 1.25
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 10.3387,
    y: 26.5462,
    className: "st0",
    width: 1.25,
    height: 1.25
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 14.0887,
    y: 26.5462,
    className: "st0",
    width: 1.25,
    height: 1.25
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 16.5887,
    y: 26.5462,
    className: "st0",
    width: 1.25,
    height: 1.25
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 26.5887,
    y: 26.5462,
    className: "st0",
    width: 1.25,
    height: 1.25
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 29.0887,
    y: 26.5462,
    className: "st0",
    width: 1.25,
    height: 1.25
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", null)));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPunchcard);
export default __webpack_public_path__ + "static/media/icon-punchcard.07aa1c4941fa4ac75118464718d93331.svg";
export { ForwardRef as ReactComponent };